import React from 'react';
import styled from "styled-components";
import { selectMenus} from '../features/menu/menuSlice';
import { useSelector } from 'react-redux';

function Header() {
  return <Container>
      <a> <img src="/image/output-onlinejpgtools.png"/></a>
      <Menu>
        <a href="#">Main</a>
        <a href="#">About Server</a>
        <a href="#">About us</a>
      </Menu>
  </Container>
}

export default Header;

const Container = styled.div`
  min-height: 60px;
  position: fixed;
  display: flex;
  align-items: center;
  padding: 0 20px;
`
const Menu = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   flex: 1;

    a {
      font-weight: 600;
      text-transform: uppercase;
      padding: 0 10px;
      flex-wrap: nowrap;
    }
`